import { Button } from "semantic-ui-react";

import Menu from "./Menu";

Menu.Button = Button;

export default Menu;
